import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import {
  handleFrom,
  handleTo,
  storeGet,
  STORE_KEY_LIST
} from 'mailup-react-helpers'
import { getListOfContents, getSourceById } from '../actions/actions'
import { pageState, resultsState, searchState } from '../state/page'

export const cleanupCallback =
  ({ reset }) =>
  async () => {
    reset(pageState)
    reset(resultsState)
    reset(searchState)
  }

export const searchCallback =
  ({ set, snapshot }) =>
  async (idSource, getSourceName) => {
    set(pageState, (prev) => ({ ...prev, loaded: false, loading: true }))
    try {
      const { TimeZoneCode: tzcode } = storeGet(STORE_KEY_LIST)
      if (getSourceName) {
        const sourceData = await getSourceById(idSource)
        set(pageState, (prev) => ({
          ...prev,
          sourceName: sourceData.SourceName
        }))
      } else {
        set(pageState, (prev) => ({ ...prev, searching: true }))
      }

      const searchParams = await snapshot.getPromise(searchState)

      const listOfContents = await getListOfContents(idSource, {
        ...searchParams,
        searchDateFrom: searchParams.searchDateFrom
          ? setDateFrom(handleFrom(searchParams.searchDateFrom, tzcode))
          : undefined,
        searchDateTo: searchParams.searchDateTo
          ? setDateTo(handleTo(searchParams.searchDateTo, tzcode))
          : undefined
      })

      set(resultsState, (prev) => ({
        ...prev,
        items: listOfContents.Contents,
        totalItems: listOfContents.TotalItems
      }))
    } catch (error) {
      logAppError({
        Component: 'SourceViewContent',
        Method: 'initCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
    set(pageState, (prev) => ({ ...prev, loaded: true, loading: false }))
  }

const setDateFrom = (val) => {
  const array = val.split('T')
  array[1] = '00:00:00.000Z'
  return array[0] + 'T' + array[1]
}

const setDateTo = (val) => {
  const array = val.split('T')
  array[1] = '23:23:59.999Z'
  return array[0] + 'T' + array[1]
}
